import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Tooltip, Typography, IconButton, TextField } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseMenuContent } from "./UseMenuContent";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteRow from "../../components/DeleteRow";
import { rsProgress, rsParentChilds } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CustomPagination from "../../components/CustomPagination";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function MenuLevel2(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const navigate = useNavigate();
  const { deleteMenu, getMenuList, updateMenu } = UseMenuContent();
  const [filt, setFilt] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [parentID, setParentID] = useRecoilState(rsParentChilds);
  const [childParent3, setChildParent2] = useState(
    location.state && location.state.childParent3
      ? location.state.childParent
      : undefined
  );
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [searchState, setSearchState] = useState(parentID.search4);

  useEffect(() => {
    if (parentID.search4 == "") {
      setSearchState("");
    }
    if (parentID.parent4) {
      setProgress(true);
      getMenuList(
        parentID.search4 ? parentID.search4 : "",
        parentID.parent4,
        (productmenus) => {
          setFiltered(productmenus.menues);
        },
        true
      );
    } else {
      setFiltered([]);
    }
  }, [parentID.parent4, parentID.search4]);

  useEffect(() => {
    setFilt([
      {
        columnField: "faName",
        operatorValue: "contains",
        value: parentID.search4 ? parentID.search4 : "",
      },
    ]);
  }, [parentID.search4]);

  const newFuncChilds = () => {
    return navigate("/menues/addMenu", {
      state: {
        id: parentID.parent4,
        PageScrollTo: props.PageScrollTo,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "rowIndex",
      width: 60,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "نام منو",
      width: 220,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 150,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            <Tooltip title="Delete">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  return navigate("/menues/editMenu", {
                    state: {
                      model: cellValues.row,
                      id: cellValues.row.id,
                      menuBanner: true,
                      PageScrollTo: parentID.scrolParent3,
                      childParent3: cellValues.api.getScrollPosition(),
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  title: cellValues.row.title,
                  url: cellValues.row.url,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  updateMenu(model, "-", () => {
                    getMenuList(
                      parentID.search4 ? parentID.search4 : "",
                      parentID.parent4,
                      (productmenus) => {
                        setProgress(false);
                        setFiltered(productmenus.menues);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowUpwardIcon fontSize="small" sx={{}} />
            </IconButton>

            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  title: cellValues.row.title,
                  url: cellValues.row.url,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (cellValues.row.rowIndex + 1 == filtered.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  updateMenu(model, "-", () => {
                    getMenuList(
                      parentID.search4 ? parentID.search4 : "",
                      parentID.parent4,
                      (productmenus) => {
                        setProgress(false);
                        setFiltered(productmenus.menues);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowDownwardIcon fontSize="small" sx={{}} />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "100%" }}>
      <TextField
        placeholder="جستجو منو"
        size="small"
        sx={{ mb: 2 }}
        variant="outlined"
        value={searchState ? searchState : ""}
        inputProps={{ "aria-label": "search" }}
        onChange={(evt) => {
          if (evt.target.value == "") {
            setParentID({
              ...parentID,
              search4: "",
            });
          }
          setSearchState(evt.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setParentID({
              ...parentID,
              search4: searchState,
            });
          }
        }}
      />
      <DataGrid
        disableVirtualization
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        sx={{
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "&  .MuiDataGrid-columnHeader:focus-within": {
            outline: "none",
          },
          "&  .MuiDataGrid-cell:focus-within ": {
            outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
          },
          width: "100% !important",
          "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !Important",
          },
          "&  .MuiDataGrid-filterIcon": {
            display: "none",
          },
          "& .MuiDataGrid-cell:hover": {
            color: "primary.main",
          },
          "& .MuiDataGrid-virtualScrollerRenderZone": {
            width: "100% !important",
          },
          "& .primary": {
            width: "100%",
            backgroundColor: "#ECF6E7 !important",
          },
          "& .none": {
            width: "100%",
            backgroundColor: "#fff !important",
          },
        }}
        getRowClassName={(params) => {
          if (params.row.id == props.parentlvl3) {
            return "primary";
          }
          if (params.row.id !== props.parentlvl3) {
            return "none";
          }
        }}
        columns={columns}
        rows={filtered ? filtered : []}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        hideFooter={props.ProductGroup ? true : false}
        disableMultipleColumnsFiltering={false}
        componentsProps={{
          pagination: {
            scrollTo:
              location.state && location.state.childParent3
                ? location.state.childParent3
                : childParent3,
            newFunc: newFuncChilds,
            noPage: true,
            nofab: parentID.parent4 ? false : true,
          },
        }}
      />

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"منو"}
        callback={() => {
          setProgress(true);
          deleteMenu(deleteState.id, () => {
            getMenuList(
              parentID.search4 ? parentID.search4 : "",
              parentID.parent4,
              (productmenus) => {
                setProgress(false);
                setFiltered(productmenus.menues);
              },
              false
            );
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
